"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const WebHIDHeadsets_model_1 = require("xchelper/models/WebHIDHeadsets.model");
const lodash_1 = __importDefault(require("lodash"));
class WebHIDHeadsetService {
    constructor($window, $log, $rootScope, XucPhoneEventListener, CtiProxy, electronWrapper, applicationConfiguration, XucPhoneState, ExternalEvent) {
        this.$window = $window;
        this.$log = $log;
        this.$rootScope = $rootScope;
        this.XucPhoneEventListener = XucPhoneEventListener;
        this.CtiProxy = CtiProxy;
        this.electronWrapper = electronWrapper;
        this.applicationConfiguration = applicationConfiguration;
        this.XucPhoneState = XucPhoneState;
        this.ExternalEvent = ExternalEvent;
        this.singlePageDescription = true;
        this.states = [];
        this.previousState = undefined;
        this.fillStatesArray = () => {
            [
                this.HID_RINGING,
                this.HID_OFFHOOK,
                this.HID_ONHOLD
            ].forEach(state => {
                let output = this.createOutput([{ usage: state, enable: true }]);
                if (output && output.length > 0)
                    this.states.push({ id: Number(output[0].reportId), key: state });
            });
        };
        this.disablePreviousState = (previousState) => {
            var _a;
            this.$log.debug(`HID - Disabling previous state ${this.keyToState(previousState.key)}`);
            this.electronWrapper.isElectron() ?
                this.electronWrapper.sendReport(previousState.id, new Uint8Array([0])) : (_a = this.device) === null || _a === void 0 ? void 0 : _a.sendReport(previousState.id, new Uint8Array([0]));
            this.previousState = undefined;
        };
        this.resetState = () => {
            var _a;
            this.$log.debug(`HID - Reset all states`);
            if (!this.singlePageDescription) {
                this.states.forEach(state => {
                    var _a;
                    this.electronWrapper.isElectron() ?
                        this.electronWrapper.sendReport(state.id, new Uint8Array([0])) : (_a = this.device) === null || _a === void 0 ? void 0 : _a.sendReport(state.id, new Uint8Array([0]));
                });
            }
            else {
                let state = this.states[0];
                this.electronWrapper.isElectron() ?
                    this.electronWrapper.sendReport(state.id, new Uint8Array([0])) : (_a = this.device) === null || _a === void 0 ? void 0 : _a.sendReport(state.id, new Uint8Array([0]));
            }
            this.previousState = undefined;
            this.setHeadsetState(this.HEADSET_STATE_ONLINE);
        };
        this.setupDevice = (device) => {
            var _a;
            this.headsetModel = device.vendorId;
            this.headsetName = device.productName;
            this.$rootScope.$broadcast(this.ExternalEvent.WEBHID_DEVICE_SELECTED, this.headsetName);
            this.telephonyOutputReport = this.getTelephonyOutputReport((_a = this.device) === null || _a === void 0 ? void 0 : _a.collections);
            if (this.telephonyOutputReport)
                this.singlePageDescription = this.telephonyOutputReport.length == 1;
            this.setInputListener(device);
            this.setPhoneEventsListeners();
            this.fillStatesArray();
            this.resetState();
        };
        this.processEvent = (eventCode, reportId, electronReport) => {
            let report = electronReport || this.getWebReports(reportId);
            let bits = (eventCode).toString(2).split("").reverse();
            report === null || report === void 0 ? void 0 : report.items.forEach((item, index) => {
                var _a;
                let matchingBit = bits.length > index ? bits[index] : "0";
                (_a = item.usages) === null || _a === void 0 ? void 0 : _a.forEach(usage => {
                    this.executeMatchingAction(usage, matchingBit);
                });
            });
        };
        this.getWebReports = (reportId) => {
            var _a;
            let reports = (_a = this.device) === null || _a === void 0 ? void 0 : _a.collections.flatMap(col => col.inputReports).find(report => report.reportId === reportId);
            return reports;
        };
        this.getTelephonyOutputReport = (collections) => {
            var _a;
            return (_a = collections === null || collections === void 0 ? void 0 : collections.find(c => c.usagePage == 0x0B)) === null || _a === void 0 ? void 0 : _a.outputReports;
        };
        this.executeMatchingAction = (usage, bit) => {
            const actions = {
                "B20": () => this.handleHookSwitch(bit)
            };
            const actionKey = this.toHIDCode(usage).join("");
            if (actions[actionKey])
                actions[actionKey]();
        };
        this.handleHookSwitch = (bit) => {
            this.$log.debug(`HID - Received HOOKSWITCH with value ${bit}`);
            let calls = this.XucPhoneState.getCallsWithStates();
            let isAnswerCmd = parseInt(bit) == 1;
            if (calls.length == 1)
                this.singleCallScenario(this.XucPhoneState.getState(), isAnswerCmd);
        };
        this.singleCallScenario = (lineState, isAnswerCmd) => {
            this.$log.debug(`HID - LineState ${lineState} bit ${isAnswerCmd}`);
            if (isAnswerCmd) {
                if (this.XucPhoneState.isPhoneRinging(lineState))
                    this.CtiProxy.answer();
            }
            else {
                if (this.XucPhoneState.isPhoneOffHook(lineState) && lineState != "OnHold")
                    this.CtiProxy.hangup();
                else if (lineState == "OnHold")
                    this.CtiProxy.hold();
            }
        };
        this.handlePhoneEventWithContext = (phoneEvent) => {
            var _a;
            const calls = this.XucPhoneState.getCalls();
            const callCount = calls.length;
            const callState = phoneEvent.eventType;
            this.$log.debug(`HID - PhoneEvent ${callState} for SIP Callid ${(_a = phoneEvent.userData) === null || _a === void 0 ? void 0 : _a.SIPCALLID} received while having ${callCount} call(s). Calls are:`, calls);
            if (callCount > 1) {
                this.setHeadsetState(this.HEADSET_STATE_OFFHOOK);
            }
            else if (callCount === 0) {
                this.setHeadsetState(this.HEADSET_STATE_ONLINE);
            }
            else {
                switch (callState) {
                    case 'EventRinging':
                        this.setHeadsetState(this.HEADSET_STATE_RINGING);
                        break;
                    case 'EventOnHold':
                        this.setHeadsetState(this.HEADSET_STATE_ONHOLD);
                        break;
                    default:
                        if (callState === 'EventReleased' && this.XucPhoneState.getState() === "OnHold") {
                            this.setHeadsetState(this.HEADSET_STATE_ONHOLD);
                        }
                        else if (callState === 'EventReleased' && this.XucPhoneState.getState() === "Ringing") {
                            this.setHeadsetState(this.HEADSET_STATE_RINGING);
                        }
                        else {
                            this.setHeadsetState(this.HEADSET_STATE_OFFHOOK);
                        }
                        break;
                }
            }
        };
        this.setHeadsetState = (stateBehaviors) => {
            const outputs = this.createOutput(stateBehaviors);
            outputs.forEach(output => {
                var _a;
                this.$log.debug(`HID - Sending report ${output.reportId} with value`, output.usageBin);
                this.electronWrapper.isElectron()
                    ? this.electronWrapper.sendReport(output.reportId, output.usageBin)
                    : (_a = this.device) === null || _a === void 0 ? void 0 : _a.sendReport(Number(output.reportId), output.usageBin);
            });
        };
        this.toHIDCode = (action) => {
            let decoded = action
                .toString(16)
                .toUpperCase();
            let usage = decoded.slice(-2);
            let page = decoded.slice(0, -4);
            return [page, usage];
        };
        this.keyToState = (key) => {
            let state = "UNKNOWN";
            switch (key) {
                case (this.HID_ONLINE):
                    state = "AVAILABLE";
                    break;
                case (this.HID_OFFHOOK):
                    state = "OFFHOOK";
                    break;
                case (this.HID_RINGING):
                    state = "RINGING";
                    break;
                case (this.HID_ONHOLD):
                    state = "ONHOLD";
                    break;
            }
            return state;
        };
        this.createOutput = (behaviors) => {
            const extractedBehaviors = behaviors.map(behavior => {
                const reportData = this.getMatchingReportData(behavior.usage, this.telephonyOutputReport);
                if (reportData !== undefined) {
                    return {
                        reportInfo: reportData.reportInfo,
                        itemIndex: reportData.itemIndex,
                        usageIndex: reportData.usageIndex,
                        enable: behavior.enable
                    };
                }
            }).filter(elem => elem !== undefined);
            const groupedBehaviors = lodash_1.default.groupBy(extractedBehaviors, (behavior) => behavior.reportInfo.reportId);
            const usageBinCodesPerReport = Object.entries(groupedBehaviors).map(([reportId, behaviors]) => {
                const typedBehaviors = behaviors;
                const usageBin = this.computeUsageBinaryCode(typedBehaviors);
                return { reportId, usageBin };
            });
            return usageBinCodesPerReport;
        };
        this.getMatchingReportData = (hex, telephonyOutputReport) => {
            let targetUsage = parseInt(hex, 16);
            this.$log.debug(`[getMatchingReportData] Target usage hex: ${hex}, decimal: ${targetUsage}`);
            for (let reportInfo of telephonyOutputReport || []) {
                this.$log.debug("[getMatchingReportData] Processing reportInfo:", reportInfo);
                let itemIndex = reportInfo.items.findIndex(item => item.usages.includes(targetUsage));
                this.$log.debug(`[getMatchingReportData] Found itemIndex: ${itemIndex} in reportId: ${reportInfo.reportId}`);
                const itemTotalCount = reportInfo.items.slice(0, itemIndex).map(item => item.reportCount).reduce((acc, count) => acc + count, 0);
                if (itemIndex !== -1) {
                    let reportItem = reportInfo.items[itemIndex];
                    let usageIndex = reportItem.usages.indexOf(targetUsage);
                    return { reportInfo, itemIndex: itemTotalCount, usageIndex };
                }
            }
            console.warn(`USAGE not found for this device : ${hex}`);
            return undefined;
        };
        this.HID_ONLINE = "8002A";
        this.HID_RINGING = "80018";
        this.HID_OFFHOOK = "80017";
        this.HID_ONHOLD = "80020";
        this.HEADSET_STATE_RINGING = [{ usage: this.HID_RINGING, enable: true }, { usage: this.HID_ONLINE, enable: true }, { usage: this.HID_OFFHOOK, enable: false }, { usage: this.HID_ONHOLD, enable: false }];
        this.HEADSET_STATE_OFFHOOK = [{ usage: this.HID_RINGING, enable: false }, { usage: this.HID_ONLINE, enable: true }, { usage: this.HID_OFFHOOK, enable: true }, { usage: this.HID_ONHOLD, enable: false }];
        this.HEADSET_STATE_DISABLED = [{ usage: this.HID_RINGING, enable: false }, { usage: this.HID_ONLINE, enable: false }, { usage: this.HID_OFFHOOK, enable: false }, { usage: this.HID_ONHOLD, enable: false }];
        this.HEADSET_STATE_ONLINE = [{ usage: this.HID_RINGING, enable: false }, { usage: this.HID_ONLINE, enable: true }, { usage: this.HID_OFFHOOK, enable: false }, { usage: this.HID_ONHOLD, enable: false }];
        this.HEADSET_STATE_ONHOLD = [{ usage: this.HID_RINGING, enable: false }, { usage: this.HID_ONLINE, enable: true }, { usage: this.HID_OFFHOOK, enable: true }, { usage: this.HID_ONHOLD, enable: true }];
        this.getCurrentDeviceName = () => {
            return this.headsetName;
        };
        this.setCurrentDeviceName = (_, name) => {
            return this.headsetName = name;
        };
        this.$log.info("HID - Starting webHID headset service");
        this.headsetProvider = new WebHIDHeadsets_model_1.HeadsetsProvider(this.applicationConfiguration);
        this.$rootScope.$on(this.ExternalEvent.WEBHID_INPUT_TYPE, this.processElectronHIDInput.bind(this));
        this.$rootScope.$on(this.ExternalEvent.WEBHID_LED_OUTPUTS_REPORTS, this.processElectronReports.bind(this));
        this.$rootScope.$on(this.ExternalEvent.WEBHID_DEVICE_SELECTED, this.setCurrentDeviceName.bind(this));
        if (this.electronWrapper.isElectron())
            this.electronWrapper.HIDServiceReady();
    }
    init() {
        return __awaiter(this, void 0, void 0, function* () {
            let filters = this.headsetProvider.getSupportedVendors();
            this.electronWrapper.isElectron() ? this.electronHandler(filters) : this.webHandler(filters);
        });
    }
    processElectronReports(_, data) {
        this.telephonyOutputReport = this.getTelephonyOutputReport(JSON.parse(data).collections);
        if (this.telephonyOutputReport)
            this.singlePageDescription = this.telephonyOutputReport.length == 1;
        this.fillStatesArray();
        this.resetState();
        this.setPhoneEventsListeners();
    }
    setInputListener(device) {
        device.addEventListener('inputreport', (e) => {
            const { data, reportId } = e;
            let eventCode;
            if (data.buffer) {
                let uia = new Uint8Array(data.buffer);
                eventCode = uia[0];
            }
            else
                eventCode = data.getUint8(0);
            this.processEvent(eventCode, reportId);
        });
    }
    electronHandler(filters) {
        this.electronWrapper.requestWebHID(filters);
    }
    processElectronHIDInput(_, data) {
        this.$log.debug("HID - Received external HID input", data);
        this.headsetModel = this.headsetProvider.getHeadsetModelByVendorID(data.vendorId);
        if (this.headsetModel) {
            this.processEvent(data.code, data.reportId, data.report);
        }
        else
            this.$log.warn(`HID - This device is not supported for webHID`);
    }
    webHandler(filters) {
        return __awaiter(this, void 0, void 0, function* () {
            filters = filters.map(filter => { return { vendorId: filter }; });
            try {
                let [device] = yield this.$window.navigator.hid.requestDevice({ filters });
                if (device) {
                    this.headsetModel = this.headsetProvider.getHeadsetModelByVendorID(device.vendorId);
                    if (this.headsetModel) {
                        yield this.openDevice(device);
                        this.$window.localStorage.setItem("HID_DEVICE", JSON.stringify({ vendorId: device.vendorId, productId: device.productId }));
                    }
                    else
                        this.$log.warn(`HID - This device is not supported for webHID: ${device.productName}`);
                }
            }
            catch (e) {
                console.error(e);
            }
        });
    }
    setPhoneEventsListeners() {
        this.XucPhoneEventListener.addDialingHandler(this.$rootScope, this.handlePhoneEventWithContext);
        this.XucPhoneEventListener.addRingingHandler(this.$rootScope, this.handlePhoneEventWithContext);
        this.XucPhoneEventListener.addEstablishedHandler(this.$rootScope, this.handlePhoneEventWithContext);
        this.XucPhoneEventListener.addReleasedHandler(this.$rootScope, this.handlePhoneEventWithContext);
        this.XucPhoneEventListener.addOnHoldHandler(this.$rootScope, this.handlePhoneEventWithContext);
    }
    computeUsageBinaryCode(behaviors) {
        const usageBinCodes = behaviors.map(behavior => {
            return (Number(behavior.enable) << behavior.usageIndex) << behavior.itemIndex;
        });
        const summedUsageBinCode = usageBinCodes.reduce((acc, current) => acc + current, 0);
        return new Uint8Array([summedUsageBinCode]);
    }
    getDeviceFromBrowser(device) {
        return this.$window.navigator.hid.getDevices().then((devices) => {
            return devices.find((d) => d.vendorId == device.vendorId && d.productId == device.productId);
        });
    }
    openDevice(device) {
        return __awaiter(this, void 0, void 0, function* () {
            if (device) {
                try {
                    yield device.open();
                    this.device = device;
                    this.setupDevice(device);
                }
                catch (e) {
                    this.$log.warn(`HID - Could not open WebHID device ${device.productName}`);
                    this.$log.debug("HID - Reason :", e);
                }
            }
        });
    }
    uninit() {
        if (this.electronWrapper.isElectron())
            this.electronWrapper.uninitWebHID();
        else if (this.device) {
            this.resetState();
            this.device.close();
            this.device = undefined;
            this.headsetModel = undefined;
            this.headsetName = undefined;
            this.$window.localStorage.removeItem("HID_DEVICE");
            this.$rootScope.$broadcast(this.ExternalEvent.WEBHID_DEVICE_SELECTED, undefined);
        }
    }
}
exports.default = WebHIDHeadsetService;
WebHIDHeadsetService.$inject = ["$window", "$log", "$rootScope", "XucPhoneEventListener", "CtiProxy", "electronWrapper", "applicationConfiguration", "XucPhoneState", "ExternalEvent"];
